module.exports = __webpack_public_path__ + "assets/img/_Novo Show Unit_Bedroom_RGB_lr.d83f626f.jpg";